import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  Icon,
  Link,
  useColorModeValue,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  useColorMode,
  ModalCloseButton,
  ModalFooter,
  Grid,
  useDisclosure
} from "@chakra-ui/react";
import NiceButton from "components/NiceButton/NiceButton.js";
import React, { useState } from "react";
import config from "config/index";
import { ToastContainer, toast } from 'react-toastify';
import IconBox from "components/Icons/IconBox";



function TablesTableRow(props) {
  const { id, title, status, date, isLast, address,reload,setReload } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { colorMode } = useColorMode();


  
}

export default TablesTableRow;
